export const getInstrTopGroups = (state) => state.topInstruments.topGroups.data;

export const getIsLoadingInstrTopGroups = (state) =>
  state.topInstruments.topGroups.isLoadingInstrTopGroups;

export const getSelectedInstrTopGroup = (state) =>
  state.topInstruments.topGroups.selected;

export const getTopInstruments = (state) => state.topInstruments.data;

export const getIsLoadingTopInstruments = (state) =>
  state.topInstruments.isLoadingInstruments;
